import { lazyLoad } from 'utils/loadable';

export const SalesAggregationPage = lazyLoad(
  () => import('./index'),
  module => module.SalesAggregationPage,
);
